import Button from "../../components/Button/Button";
import api from "../../js/api";

export default function Git() {
    return (
        <div id='git'>
            <div className='centered-container'>
                <h2> Git Repositories </h2>
                <br />
                <Button text={'Pull Mariú'} onClick={async () => {
                    const res = await api.post('/git/mariu/pull');
                    if (res.error) {
                        return;
                    }
                    alert('OK');
                }} class_="git-button" />

            </div>
        </div>
    );
}